import Api from "@/service/api";
import { Captcha, ThirdLogin, VerifyType } from "./enum";

// 获取邮箱验证码
export async function smsCode(params: {
  email: string;
  type: VerifyType;
  xPos?: number;
  verifyType?: string;
  uuid?: string;
}) {
  return Api.request({
    url: "/member/sendEmailVerify",
    method: "POST",
    params,
    headers: { uuid: params?.uuid },
  });
}

// 注册
export async function register(options?: { [key: string]: any }) {
  return Api.request({
    url: "/member/signup",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 登录
export async function login(
  options?: { [key: string]: any },
  xPos?: number,
  verifyType?: string,
  uuid?: string,
) {
  if(uuid) {
    return Api.request({
      url: `/member/signIn?xPos=${xPos}&verifyType=${verifyType}`,
      method: "POST",
      data: {
        ...(options || {}),
      },
      headers: { uuid },
    });
  }

  return Api.request({
    url: "/member/signIn",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 获取deviceId
export async function getDeviceId() {
  return Api.request({
    url: "/member/tourists/gen/id",
    method: "GET",
  });
}

// 退出登录
export async function logout() {
  return Api.request({
    url: "/member/logout",
    method: "GET",
  });
}
// 重置密码
export async function resetPassword(options?: { [key: string]: any }) {
  return Api.request({
    url: "/member/reset-pass",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 获取滑块验证码
export async function getCaptcha(uuid: string, verificationEnums?: Captcha) {
  return Api.request({
    url: `/member/getCaptcha/${verificationEnums}`,
    method: "POST",
    headers: { uuid },
  });
}

// 验证码预校验
export async function preCheck(
  uuid: string,
  verificationEnums: Captcha,
  xPos: number,
) {
  return Api.request({
    url: `/member/preCheck/${verificationEnums}`,
    method: "POST",
    headers: { uuid },
    params: { xPos },
  });
}

// 记录用户cookie信息
export async function cookieRecord(
  deviceId: string,
  options?: { [key: string]: any },
) {
  return Api.request({
    url: `/member/cookieRecord`,
    method: "POST",
    headers: { deviceId },
    data: {
      ...(options || {}),
    },
  });
}

// 判断用户是否已注册
export async function queryUserSigned(params: { email: string }) {
  return Api.request({
    url: "/member/queryUserSigned",
    method: "POST",
    params,
  });
}

// google登录
export async function googleLogin(token: string) {
  return Api.request({
    url: "/member/auth/google/googleTokenLogin",
    method: "GET",
    params: {
      token,
    },
  });
}

// facebook登录
export async function facebookLogin(token: string) {
  return Api.request({
    url: "/member/auth/google/facebookTokenLogin",
    method: "GET",
    params: {
      token,
    },
  });
}

// 检验邮箱是否注册
export async function verifyEmailThirdLogin(email: string, token: string | undefined, loginPlatform: ThirdLogin) {
  return Api.request({
    url: "/member/checkEmailSignup",
    method: "POST",
    params: {
      email,
      token,
      loginPlatform,
    },
  });
}

// 绑定邮箱
export async function thirdUserBindEmail(options?: { [key: string]: any }) {
  return Api.request({
    url: "/member/thirdUserBindEmail",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}